import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { redirect } from '../lib/utils/browser';
import { LENOVO_EDUCATION_URL } from '../constants';


const ReturnToLenovoButtonComponent = () => {

    return (
        <button
            type="button"
            className="sid-btn"
            aria-label="submit"
            onClick={() => {
                redirect(LENOVO_EDUCATION_URL);
            }}
            onKeyPress={() => {
                redirect(LENOVO_EDUCATION_URL);
            }}
            tabIndex={0}
        >
            <FormattedHTMLMessage id="step.success.redirect" defaultMessage="Continue to Lenovo" />
        </button>
    );
};

export { ReturnToLenovoButtonComponent };
